import React from "react";

const SimilarFoodCard = ({ chosenOne, setChosenOne, food }) => {
  const handleSelect = (e) => {
    console.log('SimilarFoodCard selected!', food.foodname, 'Food ID:', food.id);
    e.preventDefault();
    e.stopPropagation();
    setChosenOne({
      id: food.id,
      eyemesurementnumber: food.eyemesurementnumber,
      foodName: food.foodname,
    });
  };

  const isSelected = chosenOne.id === food.id;

  return (
    <div
      onClick={handleSelect}
      onTouchEnd={handleSelect}
      className={
        "flex items-center justify-between gap-3 rounded-[16px] border px-5 py-4 cursor-pointer transition-all " +
        (isSelected
          ? "border-main bg-blue-50"
          : "border-gray_160 hover:border-gray_200 active:bg-gray-50")
      }
      style={{ touchAction: 'manipulation', pointerEvents: 'auto' }}
    >
      {/* Food info */}
      <div className="flex flex-col gap-1 flex-1">
        <h2 className={
          "text-base font-medium break-words " +
          (isSelected ? "text-main" : "text-black")
        }>
          {food.foodname}
        </h2>
        <div className="flex gap-1 text-[13px] text-gray_100">
          <span>{food.eyemesurementnumber}</span>
          <span>{food.eyemesurementunit}</span>
        </div>
      </div>

      {/* Selected indicator */}
      {isSelected && (
        <div className="flex items-center justify-center w-6 h-6 rounded-full bg-main">
          <svg className="w-4 h-4 text-white" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
            <path d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
      )}
    </div>
  );
};

export default SimilarFoodCard;
